export default "__VITE_ASSET__C_pRmGOt__"